export default __webpack_public_path__ + "static/media/exercs.2fcbb976.png";